var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 664.15 800.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .logo {\n        fill: #ede9e4;\n      }\n\n      .rect {\n        fill: #333;\n        translate: 0 -100%;\n      }\n\n      "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 121",
    className: "logo",
    d: "M664.15,800.46H0v-161.9L253.02,0h158.14l253,638.56v161.9ZM293.98,369.34l-84.43,213.17c-8.32,21.04,1.99,44.84,23.03,53.16,4.78,1.89,9.87,2.86,15.01,2.87h168.86c22.62-.03,40.94-18.4,40.9-41.03,0-5.14-.98-10.23-2.87-15.01l-84.34-213.17c-8.35-21.03-32.16-31.31-53.19-22.97-10.49,4.16-18.8,12.47-22.97,22.97"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 341",
    className: "rect rect-1",
    width: 51.58,
    height: 800.46
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 347",
    className: "rect rect-2",
    x: 612.57,
    width: 51.58,
    height: 800.46
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 345",
    className: "rect rect-3",
    x: 390.11,
    width: 48.36,
    height: 800.46
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 344",
    className: "rect rect-4",
    x: 335.3,
    width: 45.14,
    height: 800.46
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 342",
    className: "rect rect-5",
    x: 58.03,
    width: 103.17,
    height: 800.46
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 343",
    className: "rect rect-6",
    x: 170.87,
    width: 157.98,
    height: 800.46
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 346",
    className: "rect rect-7",
    x: 448.14,
    width: 157.98,
    height: 800.46
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 346",
    className: "rect rect-main",
    x: 0,
    width: 664.15,
    height: 800.46
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.99b375b0d2915fad384a41d71db805c4.svg";
export { ForwardRef as ReactComponent };